/**
 * Carousel for selfie pictures.
 **/
app.add({
    
    Carousel: function(node){
        this.current = 0;
        this.items = $(node).find('li');
        $(node).find('.prev')[0].addEventListener('click', this);
        $(node).find('.next')[0].addEventListener('click', this);
        window.addEventListener('resize', this);
        window.addEventListener('load', this);
    },

    CarouselPrototype: {
        handleEvent: function(e){
            var method = e.target.className || 'onResize';
            this[method](e);
        },
        onResize: function(){
            var item = this.items.first();
            var visible_number = Math.round(item.closest('.carousel').width()/item.width());
            this.length = this.items.length - visible_number;
        },
        next: function(){
            if (this.current < this.length) {
                this.move(+1);
            }
        },
        prev: function(){
            if (this.current) {
                this.move(-1);
            }
        },
        move: function(d){
            this.current += d;
            this.items.css('transform', 'translate3d('.concat(-100*this.current, '%, 0, 0)'));
        }
    },

    init: function(){
        this.Carousel.prototype = this.CarouselPrototype;
    },

    onLoad: function(){
        var carousels = $('.carousel'), i = carousels.length;
        while (i--){
            new this.Carousel(carousels[i]);
        }
    }

});













// WEBPACK FOOTER //
// ./resources/assets/js/modules/carousel.js